(function () {
  'use strict';

  const quiz = document.getElementById('quiz-fathers-day');
  if (!quiz) return;

  const totalQuestions = parseInt(quiz.dataset.totalQuestions, 10);
  const screens = quiz.querySelectorAll('.quiz-fd__screen');
  const progressBar = quiz.querySelector('.quiz-fd__progress');
  const progressFill = quiz.querySelector('#quizProgressFill');
  const progressText = quiz.querySelector('#quizProgressText');
  const progressDots = quiz.querySelectorAll('.quiz-fd__progress-dot');
  const resultsScreen = quiz.querySelector('[data-screen="results"]');
  const resultBlocks = quiz.querySelectorAll('.quiz-fd__result');

  let currentStep = 0; // 0 = intro, 1..n = questions
  let answers = {}; // { stepNumber: tagValue }

  // --- Screen Management ---

  function showScreen(screenType, step) {
    screens.forEach(function (s) {
      s.classList.remove('active');
    });

    if (screenType === 'intro') {
      quiz.querySelector('[data-screen="intro"]').classList.add('active');
      progressBar.classList.remove('visible');
    } else if (screenType === 'question') {
      var questionScreen = quiz.querySelector(
        '[data-screen="question"][data-step="' + step + '"]'
      );
      if (questionScreen) {
        questionScreen.classList.add('active');
        progressBar.classList.add('visible');
        updateProgress(step);
      }
    } else if (screenType === 'results') {
      resultsScreen.classList.add('active');
      progressBar.classList.remove('visible');
      showResult();
    }
  }

  function updateProgress(step) {
    // Fill through the current active dot (not just up to it)
    var pct = ((step) / totalQuestions) * 100;
    // Cap at 100% for the last question
    if (step >= totalQuestions) pct = 100;
    progressFill.style.width = pct + '%';
    progressText.textContent = step + ' / ' + totalQuestions;

    progressDots.forEach(function (dot, i) {
      dot.classList.remove('active', 'completed');
      if (i + 1 < step) {
        dot.classList.add('completed');
      } else if (i + 1 === step) {
        dot.classList.add('active');
      }
    });
  }

  // --- Answer Selection ---

  quiz.addEventListener('click', function (e) {
    var answerBtn = e.target.closest('.quiz-fd__answer');
    if (answerBtn) {
      handleAnswerClick(answerBtn);
      return;
    }

    var actionBtn = e.target.closest('[data-action]');
    if (actionBtn) {
      handleAction(actionBtn.dataset.action);
    }
  });

  function handleAnswerClick(btn) {
    var step = parseInt(btn.dataset.step, 10);
    var tag = btn.dataset.tag;

    // Deselect siblings
    var siblings = btn.parentElement.querySelectorAll('.quiz-fd__answer');
    siblings.forEach(function (s) {
      s.setAttribute('aria-pressed', 'false');
    });

    // Select this one
    btn.setAttribute('aria-pressed', 'true');
    answers[step] = tag;

    // Enable next button
    var screen = btn.closest('.quiz-fd__screen');
    var nextBtn = screen.querySelector('[data-action="next"]');
    if (nextBtn) {
      nextBtn.disabled = false;
    }

    // Auto-advance after a short delay
    setTimeout(function () {
      if (currentStep < totalQuestions) {
        currentStep++;
        showScreen('question', currentStep);
        restoreSelection(currentStep);
      } else {
        showScreen('results');
      }
    }, 400);
  }

  function handleAction(action) {
    switch (action) {
      case 'start':
        currentStep = 1;
        showScreen('question', 1);
        break;
      case 'next':
        if (currentStep < totalQuestions) {
          currentStep++;
          showScreen('question', currentStep);
          // Restore selection state if going back then forward
          restoreSelection(currentStep);
        } else {
          showScreen('results');
        }
        break;
      case 'back':
        if (currentStep > 1) {
          currentStep--;
          showScreen('question', currentStep);
          restoreSelection(currentStep);
        }
        break;
      case 'retake':
        answers = {};
        currentStep = 0;
        // Reset all selections
        quiz.querySelectorAll('.quiz-fd__answer').forEach(function (btn) {
          btn.setAttribute('aria-pressed', 'false');
        });
        quiz.querySelectorAll('[data-action="next"]').forEach(function (btn) {
          btn.disabled = true;
        });
        // Hide all results
        resultBlocks.forEach(function (r) {
          r.style.display = 'none';
        });
        showScreen('intro');
        break;
    }
  }

  function restoreSelection(step) {
    if (answers[step]) {
      var screen = quiz.querySelector(
        '[data-screen="question"][data-step="' + step + '"]'
      );
      var nextBtn = screen.querySelector('[data-action="next"]');
      if (nextBtn) nextBtn.disabled = false;
    }
  }

  // --- Result Matching ---

  function showResult() {
    // Build combo keys to try (most specific to least)
    var tags = [];
    for (var i = 1; i <= totalQuestions; i++) {
      if (answers[i]) tags.push(answers[i]);
    }

    // Try progressively shorter combos: all tags, first 2, first 1, then default
    var keysToTry = [];
    if (tags.length >= 3) keysToTry.push(tags.slice(0, 3).join('-'));
    if (tags.length >= 2) keysToTry.push(tags.slice(0, 2).join('-'));
    if (tags.length >= 1) keysToTry.push(tags[0]);
    keysToTry.push('default');

    var matched = null;
    for (var k = 0; k < keysToTry.length; k++) {
      var key = keysToTry[k];
      for (var r = 0; r < resultBlocks.length; r++) {
        if (resultBlocks[r].dataset.comboKey === key) {
          matched = resultBlocks[r];
          break;
        }
      }
      if (matched) break;
    }

    // Show matched result
    resultBlocks.forEach(function (r) {
      r.style.display = 'none';
    });

    if (matched) {
      matched.style.display = 'block';
    }
  }

  // --- Init ---
  showScreen('intro');
})();
